import { render, staticRenderFns } from "./relationInfoTable.vue?vue&type=template&id=0ac098a2"
import script from "./relationInfoTable.vue?vue&type=script&lang=js"
export * from "./relationInfoTable.vue?vue&type=script&lang=js"
import style0 from "./relationInfoTable.vue?vue&type=style&index=0&id=0ac098a2&prod&lang=stylus"
import style1 from "./relationInfoTable.vue?vue&type=style&index=1&id=0ac098a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports